import React, { useEffect, useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Calendar, MapPin, Clock, Users, DollarSign, FileText, Mail } from 'lucide-react';
export function MidwestCup2026Page() {
  const [selectedPackage, setSelectedPackage] = useState<string>('');
  const [selectedEvent, setSelectedEvent] = useState<string>('');
  const [noRefundsAgreed, setNoRefundsAgreed] = useState(false);
  const [liabilityWaiverAgreed, setLiabilityWaiverAgreed] = useState(false);
  const [rulePacketReceived, setRulePacketReceived] = useState(false);
  useEffect(() => {
    document.title = "Midwest Cup 2026 | Walker's Martial Arts | Bloomington, Illinois";
    // Handle hash navigation
    const hash = window.location.hash;
    if (hash === '#registration') {
      setTimeout(() => {
        const element = document.getElementById('registration');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    }
  }, []);
  const registrationPackages = [{
    id: '1-event',
    name: '1 EVENT',
    price: 65.0,
    hasOptions: true,
    options: ['FORMS', 'SPARRING', 'BREAKING'],
    helperText: 'Choose one event.'
  }, {
    id: '2-events',
    name: '2 EVENTS',
    price: 75.0,
    hasOptions: true,
    options: ['FORMS / SPARRING', 'FORMS / BREAKING', 'SPARRING / BREAKING'],
    helperText: 'Choose two events.'
  }, {
    id: 'all-events',
    name: 'ALL EVENTS',
    price: 85.0,
    hasOptions: false,
    options: [],
    helperText: 'Includes all events.'
  }];
  return <div className="bg-black min-h-screen" data-id="element-1368">
      <Navigation data-id="element-1369" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-20 overflow-hidden" data-id="element-1370">
        <div className="absolute inset-0 z-0" data-id="element-1371">
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black" data-id="element-1372" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1373">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center" data-id="element-1374">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] text-sm font-semibold mb-6" data-id="element-1375">
              <span className="w-2 h-2 rounded-full bg-[#00D4FF] animate-pulse" data-id="element-1376" />
              Registration Now Open
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-4" data-id="element-1377">
              MIDWEST CUP <span className="text-[#00D4FF]" data-id="element-1378">2026</span>
            </h1>
            <p className="text-xl text-gray-400 mb-6" data-id="element-1379">WALKER'S MARTIAL ARTS</p>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto" data-id="element-1380">
              Registration has opened for the 2026 Midwest Cup Taekwondo
              tournament hosted by Walker's Martial Arts.
            </p>
            <div className="mt-8" data-id="element-1381">
              <a href="#registration" onClick={e => {
              e.preventDefault();
              const el = document.getElementById('registration');
              if (el) el.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }} className="inline-flex items-center gap-2 bg-[#00D4FF] text-black px-8 py-4 rounded font-bold text-lg uppercase tracking-wider hover:bg-[#33ddff] transition-colors shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.6)]" data-id="element-1382">
                Register Now
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Important Info Section */}
      <section className="py-16 bg-[#0a0a0a]" data-id="element-1383">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1384">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-1385">
            <h2 className="text-2xl font-bold text-white mb-6" data-id="element-1386">
              Important Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-1387">
              <ul className="space-y-4" data-id="element-1388">
                <li className="flex items-start gap-3 text-gray-300" data-id="element-1389">
                  <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-1390" />
                  <span data-id="element-1391">
                    All styles welcome! Forms Breaking & Olympic Sparring Ages 3
                    & up
                  </span>
                </li>
                <li className="flex items-start gap-3 text-gray-300" data-id="element-1392">
                  <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-1393" />
                  <span data-id="element-1394">Spectator fees only $10.00 (age 4 & under free)</span>
                </li>
                <li className="flex items-start gap-3 text-gray-300" data-id="element-1395">
                  <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-1396" />
                  <span data-id="element-1397">ALL payments must be made by June 13 2026</span>
                </li>
                <li className="flex items-start gap-3 text-gray-300" data-id="element-1398">
                  <div className="w-2 h-2 bg-[#00D4FF] rounded-full mt-2 shrink-0" data-id="element-1399" />
                  <span data-id="element-1400">No refunds once registered</span>
                </li>
              </ul>
              <div className="rounded-xl overflow-hidden" data-id="element-1401">
                <img src="https://cdn.magicpatterns.com/uploads/mBwwbjLyyKdWYDDhGjGMEd/IMG_2013.jpg" alt="Midwest Cup Tournament Group Photo" className="w-full h-full object-cover rounded-xl" data-id="element-1402" />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-1403">
              <a href="https://www.walkerskicks.com/s/2026-Midwest-Cup-1-6.pdf" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-[#00D4FF] text-black px-6 py-3 rounded font-bold uppercase tracking-wider hover:bg-[#33ddff] transition-colors" data-id="element-1404">
                <FileText className="w-5 h-5" data-id="element-1405" />
                Tournament Packet Here
              </a>
              <a href="/contact" className="flex items-center justify-center gap-2 border border-[#00D4FF] text-[#00D4FF] px-6 py-3 rounded font-bold uppercase tracking-wider hover:bg-[#00D4FF]/10 transition-colors" data-id="element-1406">
                <Mail className="w-5 h-5" data-id="element-1407" />
                Contact Us for Sponsorship Info!
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Event Details Section */}
      <section className="py-16 bg-black" data-id="element-1408">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1409">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1410">
            Event Details
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1411">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-1412">
              <div className="flex items-center gap-3 mb-4" data-id="element-1413">
                <Calendar className="w-6 h-6 text-[#00D4FF]" data-id="element-1414" />
                <h3 className="text-xl font-bold text-white" data-id="element-1415">Date</h3>
              </div>
              <p className="text-gray-300 text-lg" data-id="element-1416">July 18, 2026</p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-1417">
              <div className="flex items-center gap-3 mb-4" data-id="element-1418">
                <MapPin className="w-6 h-6 text-[#00D4FF]" data-id="element-1419" />
                <h3 className="text-xl font-bold text-white" data-id="element-1420">Venue</h3>
              </div>
              <p className="text-gray-300 text-lg" data-id="element-1421">
                Illinois Wesleyan University
              </p>
              <p className="text-gray-400 text-sm mt-1" data-id="element-1422">
                302 E. Emerson Street, Bloomington, Illinois
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-1423">
              <div className="flex items-center gap-3 mb-4" data-id="element-1424">
                <Clock className="w-6 h-6 text-[#00D4FF]" data-id="element-1425" />
                <h3 className="text-xl font-bold text-white" data-id="element-1426">Schedule</h3>
              </div>
              <ul className="space-y-2 text-gray-300" data-id="element-1427">
                <li data-id="element-1428">Doors Open: 8:00 a.m.</li>
                <li data-id="element-1429">Blackbelt & Judges Meeting: 9:30 a.m.</li>
                <li data-id="element-1430">Opening Ceremony: 10:00 a.m.</li>
                <li data-id="element-1431">Tournament Starts: 10:30 a.m.</li>
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="bg-[#1a1a1a] p-6 rounded-xl border border-gray-800" data-id="element-1432">
              <div className="flex items-center gap-3 mb-4" data-id="element-1433">
                <Users className="w-6 h-6 text-[#00D4FF]" data-id="element-1434" />
                <h3 className="text-xl font-bold text-white" data-id="element-1435">
                  Who Can Compete
                </h3>
              </div>
              <p className="text-gray-300" data-id="element-1436">
                All styles welcome! Open to competitors ages 3 and up.
              </p>
            </motion.div>
          </div>

          {/* CTA after Event Details */}
          <div className="mt-12 text-center" data-id="element-1437">
            <a href="#registration" onClick={e => {
            e.preventDefault();
            const el = document.getElementById('registration');
            if (el) el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }} className="inline-flex items-center gap-2 bg-[#00D4FF] text-black px-8 py-4 rounded font-bold text-lg uppercase tracking-wider hover:bg-[#33ddff] transition-colors shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.6)]" data-id="element-1438">
              Register Now
            </a>
          </div>
        </div>
      </section>

      {/* Photo Gallery */}
      <section className="py-12 bg-black" data-id="element-1439">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1440">
          <h2 className="text-3xl font-bold text-white mb-4 text-center" data-id="element-1441">
            Tournament Highlights
          </h2>
          <p className="text-gray-400 text-center mb-8" data-id="element-1442">
            Moments from previous Midwest Cup tournaments
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3" data-id="element-1443">
            {['https://cdn.magicpatterns.com/uploads/s1EaH8jGE1a4BfDP159cYS/IMG_2063.jpg', 'https://cdn.magicpatterns.com/uploads/hrG4cHt623JJyY3ksJF4Fz/IMG_2118.jpg', 'https://cdn.magicpatterns.com/uploads/wV49eLXwMjS4CtWkguThDR/IMG_2119.jpg', 'https://cdn.magicpatterns.com/uploads/3CdZRDkj28sLGLCw829pcX/IMG_2129.jpg', 'https://cdn.magicpatterns.com/uploads/1DESB6L3sQbZYFCs6G1Rob/IMG_2246.jpg', 'https://cdn.magicpatterns.com/uploads/c8x5awK86Y8zyPGajYhCur/IMG_2284.jpg', 'https://cdn.magicpatterns.com/uploads/hrw6egrFZqCYyQdh1KJPtZ/IMG_2304.jpg', 'https://cdn.magicpatterns.com/uploads/5HPA9BPJqBordRsAS2zBwb/IMG_2360.jpg', 'https://cdn.magicpatterns.com/uploads/7hTDpvubmA2B98rcnkYDKK/IMG_2379.jpg', 'https://cdn.magicpatterns.com/uploads/nVw2DztgXtQdqEb25SuEPt/IMG_2432.jpg', 'https://cdn.magicpatterns.com/uploads/j8wQMw92GjVJic74Z6Ftg5/IMG_2035.jpg', 'https://cdn.magicpatterns.com/uploads/2daCRfFCrjCAFJRhpmJym2/IMG_2509.jpg'].map((src, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="rounded-lg overflow-hidden aspect-[4/3]" data-id="element-1444">
                <img src={src} alt={`Midwest Cup Tournament Photo ${index + 1}`} className="w-full h-full object-cover" data-id="element-1445" />
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Registration Packages Section */}
      <section id="registration" className="py-16 bg-[#0a0a0a]" data-id="element-1446">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1447">
          <h2 className="text-3xl font-bold text-white mb-4 text-center" data-id="element-1448">
            Tournament Registration
          </h2>
          <p className="text-gray-400 text-center mb-12" data-id="element-1449">
            Choose your registration package below
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1450">
            {registrationPackages.map((pkg, index) => <motion.div key={pkg.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800 hover:border-[#00D4FF]/50 transition-all" data-id="element-1451">
                <div className="text-center mb-6" data-id="element-1452">
                  <h3 className="text-2xl font-bold text-white mb-2" data-id="element-1453">
                    {pkg.name}
                  </h3>
                  <div className="flex items-center justify-center gap-1 mb-4" data-id="element-1454">
                    <DollarSign className="w-8 h-8 text-[#00D4FF]" data-id="element-1455" />
                    <span className="text-4xl font-bold text-white" data-id="element-1456">
                      {pkg.price.toFixed(2)}
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm" data-id="element-1457">{pkg.helperText}</p>
                </div>

                {pkg.hasOptions && <div className="mb-6" data-id="element-1458">
                    <label className="block text-sm font-medium text-gray-400 mb-3" data-id="element-1459">
                      {pkg.id === '1-event' ? 'EVENT:' : 'EVENTS:'}
                    </label>
                    <select className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" value={selectedPackage === pkg.id ? selectedEvent : ''} onChange={e => {
                setSelectedPackage(pkg.id);
                setSelectedEvent(e.target.value);
              }} data-id="element-1460">
                      <option value="" data-id="element-1461">Select an option</option>
                      {pkg.options.map(option => <option key={option} value={option} data-id="element-1462">
                          {option}
                        </option>)}
                    </select>
                  </div>}

                <div className="mb-6 space-y-3" data-id="element-1463">
                  <label className="flex items-start gap-3 text-sm text-gray-300 cursor-pointer" data-id="element-1464">
                    <input type="checkbox" checked={noRefundsAgreed} onChange={e => setNoRefundsAgreed(e.target.checked)} className="mt-1 w-4 h-4 rounded border-gray-700 bg-black text-[#00D4FF] focus:ring-2 focus:ring-[#00D4FF] focus:ring-offset-0" required data-id="element-1465" />
                    <span data-id="element-1466">
                      I understand there are no refunds once registered
                    </span>
                  </label>

                  <label className="flex items-start gap-3 text-sm text-gray-300 cursor-pointer" data-id="element-1467">
                    <input type="checkbox" checked={liabilityWaiverAgreed} onChange={e => setLiabilityWaiverAgreed(e.target.checked)} className="mt-1 w-4 h-4 rounded border-gray-700 bg-black text-[#00D4FF] focus:ring-2 focus:ring-[#00D4FF] focus:ring-offset-0" required data-id="element-1468" />
                    <span data-id="element-1469">I have read and agree to liability waiver</span>
                  </label>

                  <label className="flex items-start gap-3 text-sm text-gray-300 cursor-pointer" data-id="element-1470">
                    <input type="checkbox" checked={rulePacketReceived} onChange={e => setRulePacketReceived(e.target.checked)} className="mt-1 w-4 h-4 rounded border-gray-700 bg-black text-[#00D4FF] focus:ring-2 focus:ring-[#00D4FF] focus:ring-offset-0" required data-id="element-1471" />
                    <span data-id="element-1472">I have received tournament rule packet</span>
                  </label>
                </div>

                <a href="/contact" className={`w-full py-3 rounded font-bold uppercase tracking-wider transition-colors block text-center ${noRefundsAgreed && liabilityWaiverAgreed && rulePacketReceived ? 'bg-[#00D4FF] text-black hover:bg-[#33ddff]' : 'bg-gray-700 text-gray-500 cursor-not-allowed'}`} onClick={e => {
              if (!noRefundsAgreed || !liabilityWaiverAgreed || !rulePacketReceived) {
                e.preventDefault();
              }
            }} data-id="element-1473">
                  Register
                </a>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="mt-12 text-center" data-id="element-1474">
            <p className="text-gray-400 text-sm" data-id="element-1475">
              Registration closes June 13, 2026. No refunds once registered.
            </p>
          </motion.div>
        </div>
      </section>

      <Footer data-id="element-1476" />
    </div>;
}